enum EExplorerViewType {
	List = 'List',
	Small = 'Small',
	Medium = 'Medium',
	Large = 'Large'
}

export default EExplorerViewType;
